import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'
import { queryIdToQuery } from '../utils/query'
import { selectPreviousQueryId } from './selectPreviousQueryId'

export const selectPreviousQuery = createBasicSelector(
  selectPreviousQueryId,
  queryId => queryIdToQuery(queryId) || emptyObj
)
